<div class="container">
  <div class="title">
    <h2>{{ dialogTitle }}</h2>
  </div>
  <mat-dialog-content>
    <div class="country-lists">
      <div class="left-side">
        <div class="search-bar">
          <mat-icon matPrefix>search</mat-icon>
          <input
            matInput
            placeholder="Enter country name or ISO code"
            [formControl]="searchCtrl"
          />
          <button matSuffix mat-stroked-button (click)="searchCtrl.reset()">
            clear
          </button>
        </div>
        @if (!readOnlyDialogCheck()) {
          <mat-checkbox
            class="select-all-countries"
            (change)="toggleAll($event)"
            [checked]="allCountriesSelected()"
            [indeterminate]="isAllIndeterminate()"
            [disabled]="disableAllCheckbox()"
          >
            Select all countries
          </mat-checkbox>
        }
        <div class="country-selection">
          <mat-accordion multi>
            @for (continent of sortContinents(); track continent) {
              <mat-expansion-panel
                displayMode="flat"
                [expanded]="!!searchCtrl.value"
              >
                <mat-expansion-panel-header>
                  <mat-panel-title (click)="$event.stopPropagation()">
                    <div class="continent">
                      <mat-checkbox
                        (change)="toggleContinent(continent, $event)"
                        [checked]="isContinentChecked(continent)"
                        [indeterminate]="isContinentIndeterminate(continent)"
                        [disabled]="
                          disableContinent(continent) || readOnlyDialogCheck()
                        "
                        ><strong>
                          {{ continent.name }}
                          ({{ availableCountryLength(continent) }})
                        </strong>
                      </mat-checkbox>
                    </div>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <section>
                  <div class="countries">
                    @for (
                      country of countriesByContinent[continent.code];
                      track country
                    ) {
                      <span [matTooltip]="getReadOnlyReasonTooltip(country)">
                        @if (showCountry(country)) {
                          <mat-checkbox
                            (change)="toggleCountry(country, $event)"
                            [checked]="isCountryChecked(country)"
                            [class.readOnly]="isCountryReadOnly(country)"
                            [title]="getCountryTooltip(country)"
                            [disabled]="
                              isCountryReadOnly(country) ||
                              readOnlyDialogCheck()
                            "
                          >
                            <gax-country [countryCode]="country.iso2">
                              @if (isCountryUnsupported(country)) {
                                <mat-icon
                                  matTooltip="Unsupported"
                                  class="country-info-icon"
                                  >information</mat-icon
                                >
                              }
                            </gax-country>
                          </mat-checkbox>
                        }
                      </span>
                    }
                  </div>
                </section>
              </mat-expansion-panel>
            }
          </mat-accordion>
        </div>
      </div>
      <section class="your-selections">
        <h4>Your selection ({{ selectedCountriesSortedByName.length }})</h4>
        @for (country of selectedCountriesSortedByName; track country) {
          <span [matTooltip]="getReadOnlyReasonTooltip(country)">
            <!-- @if (showCountry(country)) { -->
            <mat-checkbox
              (change)="toggleCountry(country, $event)"
              [disabled]="isCountryReadOnly(country) || readOnlyDialogCheck()"
              [checked]="isCountryChecked(country)"
              [class.readOnly]="isCountryReadOnly(country)"
              [title]="getCountryTooltip(country)"
            >
              <gax-country [countryCode]="country.iso2">
                @if (isCountryUnsupported(country)) {
                  <mat-icon matTooltip="Unsupported" class="country-info-icon"
                    >information
                  </mat-icon>
                }
              </gax-country>
            </mat-checkbox>
            <!-- } -->
          </span>
        }
      </section>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button color="secondary" mat-button (click)="close()">Close</button>
    @if (!readOnlyDialogCheck()) {
      <button color="primary" mat-button (click)="select()">
        Select ({{ selectedCountriesSortedByName.length }}) countries
      </button>
    }
  </mat-dialog-actions>
</div>
